<div class="restricted-width" [class.opened-apelacion]="isApelacionDialogOpen">
  <div class="page-title">
    <b>Llámanos |</b>
    {{ categoriaType === "Siniestro" ? "Siniestro" : "Llámanos" }} N°{{
      caso.CaseNumber
    }}
  </div>
  <hr class="page-title-hr" />

  <div class="restricted-width-864">
    <div class="title">
      Ingreso de {{ categoriaType }} -
      {{ caso?.Categoria2__c }}
      <button class="volver hollow" (click)="onCancel()">
        Volver
      </button>
    </div>
    <div class="subtitle-with-line">
      DATOS {{ categoriaType.toUpperCase() }}
    </div>
    <div class="filters-container ver-caso-top-filters">
      <div class="filter-container filter-container-selected-eds">
        <div class="filter-title">ESTACIÓN DE SERVICIO</div>
        <div class="filter selected-eds-filter">
          <ng-select
            [items]="[
              {
                label: selectedEstacion?.label,
                value: selectedEstacion?.value,
              },
            ]"
            bindLabel="label"
            bindValue="value"
            [ngModel]="selectedEstacion?.value"
            [closeOnSelect]="true"
            [clearable]="false"
            [searchable]="false"
            placeholder="Seleccionar"
            [readonly]="true"
            [disabled]="true"
          />
        </div>
      </div>

      @if (categoriaType === "Siniestro") {
        <div class="filter-container filter-container-heridos">
          <div class="filter-title required">¿HAY HERIDOS Y/O ARMAS?</div>
          <div class="filter">
            <ng-select
              [items]="[
                { label: 'Si', value: 'Si' },
                { label: 'No', value: 'No' },
              ]"
              bindLabel="label"
              bindValue="value"
              [ngModel]="heridos"
              placeholder="Seleccionar"
              [readonly]="true"
              [disabled]="true"
            />
          </div>
        </div>
      }
    </div>

    <div class="form">
      <div class="filter-container" *ngFor="let field of displayFields">
        <div class="filter-title" [class.required]="field?.required">
          {{ field?.displayLabel }}
        </div>
        <div class="filter">
          @if (field.field_type == "phone") {
            <div class="phone-input-wrapper">
              <span class="phone-prefix">+569</span>
              <input
                type="text"
                [ngModel]="formValues[getFieldKey(field)]"
                [disabled]="true"
                maxlength="8"
              />
            </div>
          } @else if (field.field_type == "textarea") {
            <textarea
              [ngModel]="formValues[getFieldKey(field)]"
              rows="5"
              [disabled]="true"
            ></textarea>
          } @else if (field.field_type == "reference") {
            <input
              type="text"
              [ngModel]="getReferenceDisplayValue(field)"
              [disabled]="true"
            />
          } @else if (field.field_type == "date") {
            <p-datepicker
              [ngModel]="formValues[getFieldKey(field)]"
              dateFormat="yy-mm-dd"
              [locale]="es"
              [firstDayOfWeek]="1"
              [disabled]="true"
            ></p-datepicker>
          } @else if (field.field_type == "datetime") {
            <p-datepicker
              [ngModel]="formValues[getFieldKey(field)]"
              dateFormat="yy-mm-dd"
              [showTime]="true"
              [locale]="es"
              [firstDayOfWeek]="1"
              [disabled]="true"
            ></p-datepicker>
          } @else {
            <input
              type="text"
              [ngModel]="formValues[getFieldKey(field)]"
              [disabled]="true"
            />
          }
        </div>
      </div>
    </div>

    @if (caso.casoReferenciado) {
      <div class="middle-subtitle-with-line">
        CASO REFERENCIADO N° {{ caso.casoReferenciado.CaseNumber }}
      </div>

      <div class="filter-container fecha-caso">
        <div class="filter-title">FECHA DE INGRESO</div>
        <div class="filter">
          <input
            type="text"
            [value]="formatFechaCaso(caso.casoReferenciado.FechaCreacion__c)"
            disabled
          />
        </div>
      </div>

      <div class="filter-container descripcion-caso">
        <div class="filter-title">DESCRIPCIÓN DEL CASO</div>
        <div class="filter">
          <textarea
            rows="5"
            [ngModel]="caso.casoReferenciado.Description"
            [disabled]="true"
          ></textarea>
        </div>
      </div>

      <div class="filter-container fecha-caso">
        <div class="filter-title">FECHA RESOLUCIÓN</div>
        <div class="filter">
          <input
            type="text"
            [value]="formatFechaCaso(caso.casoReferenciado.ClosedDate)"
            disabled
          />
        </div>
      </div>

      <div class="filter-container descripcion-caso">
        <div class="filter-title">RESOLUCIÓN DEL CASO</div>
        <div
          class="solucion-referenciado"
          [innerHTML]="caso.casoReferenciado.SolucionDelCaso__c"
        ></div>
      </div>

      <div class="middle-subtitle-with-line">APELACIÓN</div>

      <div class="filter-container fecha-caso">
        <div class="filter-title">FECHA DE INGRESO</div>
        <div class="filter">
          <input
            type="text"
            [value]="formatFechaCaso(caso.FechaCreacion__c)"
            disabled
          />
        </div>
      </div>

      <div class="filter-container descripcion-caso">
        <div class="filter-title required">MOTIVO DE APELACIÓN</div>
        <div class="filter">
          <textarea
            rows="5"
            [ngModel]="caso.Description"
            [disabled]="true"
          ></textarea>
        </div>
      </div>
    }

    @if (!caso.casoReferenciado) {
      <div class="subtitle-with-line">EVIDENCIA</div>

      <div class="filter-container fecha-caso">
        <div class="filter-title">FECHA DE INGRESO</div>
        <div class="filter">
          <input
            type="text"
            [value]="formatFechaCaso(caso.FechaCreacion__c)"
            disabled
          />
        </div>
      </div>

      <div class="filter-container descripcion-caso">
        <div class="filter-title required">DESCRIPCIÓN DEL CASO</div>
        <div class="filter">
          <textarea
            rows="5"
            [ngModel]="caso.Description"
            [disabled]="true"
          ></textarea>
        </div>
      </div>
    }

    @if (caso.Status == "Resuelto") {
      <div class="subtitle-with-line">RESOLUCIÓN DEL CASO</div>

      <div class="filter-container fecha-caso">
        <div class="filter-title">FECHA RESOLUCIÓN</div>
        <div class="filter">
          <input
            type="text"
            [value]="formatFechaCaso(caso.ClosedDate)"
            disabled
          />
        </div>
      </div>

      <div class="filter-container descripcion-caso">
        <div class="filter-title">RESOLUCIÓN DEL CASO</div>
        <div class="solucion" [innerHTML]="caso.SolucionDelCaso__c"></div>
      </div>
    }

    <div class="actions-container">
      @if (canApelar || !ocultarApelacionNoDisponible) {
        <button (click)="openApelacionDialog()" [disabled]="!canApelar">
          Ingresar Apelación
        </button>
      }
      <button class="red-button hollow" (click)="onCancel()">
        {{ cancelButtonLabel }}
      </button>
    </div>
  </div>
</div>